<subs-select
  [controlName]="controlName"
  [label]="label"
  [labelLength]="labelLength"
>
  <option *ngFor="let item of this.options" [value]="item.key">{{
    item.value
  }}</option>
</subs-select>
